<template>
  <li :class="classes" class="mdc-list-item" v-bind="$attrs" v-on="$listeners">
    <!-- @slot Graphic slot -->
    <slot name="graphic" />
    <!-- @slot Default content slot -->
    <slot />
    <span v-if="$slots['text'] || $slots['primaryText'] || $slots['secondaryText']" class="mdc-list-item__text">
      <!-- @slot Text slot -->
      <slot name="text" />
      <span v-if="$slots['primaryText']" class="mdc-list-item__primary-text">
        <!-- @slot Primary text slot -->
        <slot name="primaryText" />
      </span>
      <span v-if="$slots['secondaryText']" class="mdc-list-item__secondary-text">
        <!-- @slot Secondary text slot -->
        <slot name="secondaryText" />
      </span>
    </span>
    <!-- @slot Meta content slot -->
    <slot name="meta" />
  </li>
</template>

<script>
import { MDCRipple } from "@material/ripple";

export default {
  props: {
    /**
     * Styles the row in the activated state.
     */
    activated: {
      type: Boolean,
      default: false
    },
    /**
     * Styles the row in the selected state.
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Styles the row in the focused state.
     */
    focused: {
      type: Boolean,
      default: false
    },
    /**
     * Disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mdcRipple: undefined
    };
  },
  computed: {
    classes() {
      return {
        "mdc-list-item--activated": this.activated,
        "mdc-list-item--selected": this.selected,
        "mdc-list-item--disabled": this.disabled,
        "mdc-ripple-upgraded--background-focused": this.focused
      };
    }
  },
  watch: {
    classes() {
      this.reInstantiateRipple();
    }
  },
  mounted() {
    this.mdcRipple = MDCRipple.attachTo(this.$el);
  },
  beforeDestroy() {
    if (this.mdcRipple) {
      this.mdcRipple.destroy();
    }
  },
  methods: {
    reInstantiateRipple() {
      if (this.mdcRipple) {
        this.mdcRipple.destroy();
      }
      this.mdcRipple = MDCRipple.attachTo(this.$el);
    }
  }
};
</script>
